import styled from 'styled-components';

export const StyledFooter = styled.footer `
    width: 100%;
    min-width: 300px;
    height: 130px;
    background-color: #3c0000;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    font-family: 'Manrope', sans-serif;
    color: white;
`

export const StyledCopyright = styled.p `
    margin: 0;
    padding: 0;
    margin-bottom: 5px;
`